/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserAdminEventOrganizerV3FromJSON, InternalUserAdminEventOrganizerV3ToJSON, } from './InternalUserAdminEventOrganizerV3';
/**
 * @export
 */
export const InternalUserAdminEventResponseV3TypeEnum = {
    AdminEvent: 'admin_event'
};
/**
 * Check if a given object implements the InternalUserAdminEventResponseV3 interface.
 */
export function instanceOfInternalUserAdminEventResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('timezone' in value) || value['timezone'] === undefined)
        return false;
    return true;
}
export function InternalUserAdminEventResponseV3FromJSON(json) {
    return InternalUserAdminEventResponseV3FromJSONTyped(json, false);
}
export function InternalUserAdminEventResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'location': json['location'] == null ? undefined : json['location'],
        'newCoverPicture': json['new_cover_picture'] == null ? undefined : json['new_cover_picture'],
        'startDate': (new Date(json['start_date'])),
        'endDate': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'organizer': json['organizer'] == null ? undefined : InternalUserAdminEventOrganizerV3FromJSON(json['organizer']),
        'webinarUrl': json['webinar_url'] == null ? undefined : json['webinar_url'],
        'isInternalZoomMeeting': json['is_internal_zoom_meeting'] == null ? undefined : json['is_internal_zoom_meeting'],
        'timezone': json['timezone'],
    };
}
export function InternalUserAdminEventResponseV3ToJSON(json) {
    return InternalUserAdminEventResponseV3ToJSONTyped(json, false);
}
export function InternalUserAdminEventResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'title': value['title'],
        'description': value['description'],
        'location': value['location'],
        'new_cover_picture': value['newCoverPicture'],
        'start_date': ((value['startDate']).toISOString()),
        'end_date': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'organizer': InternalUserAdminEventOrganizerV3ToJSON(value['organizer']),
        'webinar_url': value['webinarUrl'],
        'is_internal_zoom_meeting': value['isInternalZoomMeeting'],
        'timezone': value['timezone'],
    };
}
